export enum FeatureFlag {
    DUMMY_FEATURE_FLAG = 'DUMMY_FEATURE_FLAG',
}
